module.exports = __webpack_public_path__ + "img/Money-white.66ac9b41.svg";